import MobileMenu from "../../../app/mobile-menu";

(() => {

  /*
    *	Setup the menu's event handlers
    */
  const menu = $('#main-menu');
  const menu_items = menu.children('li');
  let active_menu = $('#main-menu .hovered');

  const activate_menu = menu => {
    if (active_menu) {
      active_menu.removeClass("hovered");
      active_menu.children('ul').css({'display': 'none'});
    }

    active_menu = menu;
    menu.addClass("hovered");
    menu.children('ul').css({'display': 'inline'});
  };

  menu_items.hover(function () {
    activate_menu($(this));
  });

  /**
   * Set up mobile menu
   */
  $('#side-menu').initMobileMenu();
})();
